export const YOUTUBE_DATA_ATTRIBUTE = 'data-splide-youtube';
export const VIMEO_DATA_ATTRIBUTE = 'data-splide-vimeo';
export const HTML_VIDEO__DATA_ATTRIBUTE = 'data-splide-html-video';
